export default "__VITE_ASSET__DDp63LVS__"